(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		const megaMenus = document.querySelectorAll(".mega-menu");

     	const megaMenuTimers = new Map();

      menuLinks.forEach((link) => {
        link.addEventListener("mouseenter", (e) => {
          if (link.classList.contains("list-menu--megamenu")) {
           link.classList.add("list-menu--megamenu-visible");
           

           if (!megaMenus) return;
           megaMenus.forEach((megaMenu) => {
             // 清除旧的隐藏定时器
             clearTimeout(megaMenuTimers.get(megaMenu));

             const megaMenuPositionRight = megaMenu.getBoundingClientRect().right;
             const windowRight = window.innerWidth;
             if (megaMenuPositionRight > windowRight) {
               megaMenu.style.right = "0";
             }

             if (megaMenu == link.querySelector('.mega-menu')) {
               megaMenu.style.opacity = 1;
               megaMenu.style.display = "grid";
              //  setTimeout(() => {
              //    megaMenu.style.opacity = 1;
              //  }, 100);
              
             } else {
              megaMenu.style.display = "none";
              megaMenu.style.opacity = 0;
              //  setTimeout(() => {
              //    megaMenu.style.opacity = 0;
              //  }, 100);
              
             }
           });

      menuLinks.forEach((el) => {
        if (el !== link) {
          el.classList.remove("list-menu--megamenu-visible");
        }
      });
          } else {
            menuLinks.forEach((el) => {
              el.classList.remove("list-menu--megamenu-visible");
            });
      
            if (!megaMenus) return;
            megaMenus.forEach((megaMenu) => {
              clearTimeout(megaMenuTimers.get(megaMenu));
              if (megaMenu == link.querySelector('.mega-menu')) {
                megaMenu.style.opacity = 0;
                const timer = setTimeout(() => {
                  megaMenu.style.display = "none";
                }, 300);
                megaMenuTimers.set(megaMenu, timer);
              }
            });
          }
        });

    link.addEventListener("mouseleave", (e) => {
      if (link.classList.contains("list-menu--megamenu")) {
        if (!megaMenus) return;
        megaMenus.forEach((megaMenu) => {
          if (megaMenu == link.querySelector('.mega-menu')) {
            clearTimeout(megaMenuTimers.get(megaMenu));
            megaMenu.style.opacity = 0;
            const timer = setTimeout(() => {
              megaMenu.style.display = "none";
            }, 300);
            megaMenuTimers.set(megaMenu, timer);
          }
        });
      }
    });

  link.addEventListener("focus", (e) => {
    if (link.classList.contains("list-menu--megamenu")) {
      link.classList.add("list-menu--megamenu-visible");

      if (!megaMenus) return;
      megaMenus.forEach((megaMenu) => {
        clearTimeout(megaMenuTimers.get(megaMenu));

        const megaMenuPositionRight = megaMenu.getBoundingClientRect().right;
             const windowRight = window.innerWidth;
             if (megaMenuPositionRight > windowRight) {
               megaMenu.style.right = "0";
             }
           });
     
           menuLinks.forEach((el) => {
             if (el !== link) {
               el.classList.remove("list-menu--megamenu-visible");
             }
           });
         } else {
           menuLinks.forEach((el) => {
             el.classList.remove("list-menu--megamenu-visible");
           });
         }
       });
     });

     menu.addEventListener("mouseleave", (e) => {
      if (!megaMenus) return;
      setTimeout(() => {
            megaMenus.forEach((megaMenu) => {
              megaMenu.style.right = "auto";
            });
          }, 500);
        
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
    
        if (!megaMenus) return;
        megaMenus.forEach((megaMenu) => {
          if (megaMenu == link.querySelector('.mega-menu')) {
            clearTimeout(megaMenuTimers.get(megaMenu));
            megaMenu.style.opacity = 0;
            const timer = setTimeout(() => {
              megaMenu.style.display = "none";
            }, 300);
            megaMenuTimers.set(megaMenu, timer);
          }
        });
      });
    });


		const megaMenuTabs = () => {
			$(".mega-menu__tab-wrapper")
				.children()
				.find(".mega-menu__tab-wrapper")
				.first()
				.addClass("mega-menu__tab-wrapper--active");
			$(".mega-menu__tab-wrapper").mouseenter(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
			$(".mega-menu__tab-wrapper").focus(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
			$(".mega-menu__tab-wrapper").focusin(function (event) {
				$(".mega-menu__tab-wrapper").removeClass(
					"mega-menu__tab-wrapper--active",
				);
				$(this).addClass("mega-menu__tab-wrapper--active");
			});
		};
		megaMenuTabs();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main.querySelectorAll(".shopify-section")[0] &&
			main
				.querySelectorAll(".shopify-section")[0]
				.classList.contains("section--has-overlay")
		) {
		}

		const menuCloseBtn = document.querySelector(".header__modal-close-button");
		const mobileMenuDrawer = document.querySelector("header-drawer");
		menuCloseBtn.addEventListener("click", (e) => {
			mobileMenuDrawer.closeMenuDrawer(e);
		});
	};

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);

	header();
})();
